
const modulesFiles = require.context('./modules', true, /\.js$/);
const modules = modulesFiles.keys().reduce((modules, modulePath) => {
    const value = modulesFiles(modulePath);
    modules.push(value.default);
    return modules;
}, []);
const allRoutes = modules;
const orderArr = [
    'globalCustList',
    'custOrganization',
    'updateSearch',
    'custAuth',
    'custGoodsManage',
    'custEslCheck',
    'custApManagement',
    'custTempManagement',
    'opsManagement',
    'custInfoSearch',
    'custTaskManage',
    'custStatistics',
    'custSetting',
    'custReport',
    'custTempalte',
    'storeShortcut',
    'storeInfo',
    'storeEsls',
    'storeApManagement',
    'storeTemperature',
    'storeVirtualEsl',
    'storeTaskManage',
    'storeSetting',
    'storeReport',
    'storeOperations',
    'storeReportCenter',
];
const pushRoutes = [];
const hasOrrder = allRoutes.filter(item => {
    if (orderArr.indexOf(item.name) != -1) {
        return true;
    } else {
        pushRoutes.push(item);
        return false;
    }
});
hasOrrder.sort((a, b) => {
    return orderArr.indexOf(a.name) - orderArr.indexOf(b.name);
});
const asyncRoutes = [...hasOrrder, ...pushRoutes];

export {
    asyncRoutes
};